import { ProviderBadgeStyle } from "@app/projects/enumerators";
import React from "react";
import { convertTextToKebabCase } from "@app/shared/utility/convertTextToKebabCase";
import { formatEnumValue } from "@app/shared/utility/formatEnumValue";
import { OutlineBadge, OutlineBadgeColor } from "@app/shared/OutlineBadge";
import { ProviderNetworkTypeEnum } from "@app/shared/enums/providerNetworkTypeEnum";

interface ProviderNetworkTypeBadgeProps {
  providerNetworkType: ProviderNetworkTypeEnum;
  badgeStyle: ProviderBadgeStyle;
  testId?: string;
}

const NETWORK_TYPE_BADGE_COLORS: Record<ProviderNetworkTypeEnum, OutlineBadgeColor> = {
  [ProviderNetworkTypeEnum.Market]: OutlineBadgeColor.Purple,
  [ProviderNetworkTypeEnum.NetNew]: OutlineBadgeColor.Slate,
  [ProviderNetworkTypeEnum.Network]: OutlineBadgeColor.Blue,
  [ProviderNetworkTypeEnum.NextClosestProviders]: OutlineBadgeColor.Plain,
  [ProviderNetworkTypeEnum.Prospect]: OutlineBadgeColor.Orange,
  [ProviderNetworkTypeEnum.Unknown]: OutlineBadgeColor.Plain,
};

const ProviderNetworkTypeBadge: React.FC<ProviderNetworkTypeBadgeProps> = ({ providerNetworkType, badgeStyle, testId }) => {
  if (!providerNetworkType) {
    return;
  }

  const displayText = formatEnumValue(providerNetworkType);

  return (
    <>
    {badgeStyle === ProviderBadgeStyle.Outline &&
      <OutlineBadge
        color={NETWORK_TYPE_BADGE_COLORS[providerNetworkType] ?? OutlineBadgeColor.Plain}
        testId={testId}
      >
        {displayText}
      </OutlineBadge>
    }
    {badgeStyle === ProviderBadgeStyle.Dot &&
      <div className="provider-badge-dot">
        <span className={`provider-badge-dot-circle provider-badge-dot-${convertTextToKebabCase(providerNetworkType)}`} />
        <span>{displayText}</span>
      </div>
    }
    </>
  );
};

export default ProviderNetworkTypeBadge;
